import script from "./ComboBoxSecondary.vue?vue&type=script&setup=true&lang=js"
export * from "./ComboBoxSecondary.vue?vue&type=script&setup=true&lang=js"

import "./ComboBoxSecondary.vue?vue&type=style&index=0&id=701946f4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-701946f4"]])

export default __exports__